import { render, staticRenderFns } from "./ConsultantsSellersReports.vue?vue&type=template&id=239a880f"
import script from "./ConsultantsSellersReports.vue?vue&type=script&lang=js"
export * from "./ConsultantsSellersReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports